import React from 'react'
import { Container, Row, Col, Image } from 'react-bootstrap'
import SignUpForm from '../../components/signUpForm/SignUpForm'
import hipsterHeadphones from '../../assets/hipster-headphones.webp'

const SignUpPage = () => {
  return (
    <div className='page-wrapper bg-light'>
      <Container fluid>
        <Row>
          <Col sm={12} md={6}>
            <Image src={hipsterHeadphones} style={{objectFit:"cover"}} className="w-100 h-100" />
          </Col>
          <Col sm={12} md={6}>
            <SignUpForm />
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default SignUpPage